import axios from 'axios';
import * as Config from '../../config';

const state = {
};

const actions = {

    load_MonosCbu({ commit, dispatch },form) {
        return new Promise((resolve, reject) => {

            axios.get(Config.apiPath + 'mono/list/all/cbu/' + form.study)
                .then(
                    response => {
                        resolve(response.data);

                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
};

const mutations = {


};

export default {
    state,
    actions,
    mutations
};